<template>
  <v-container fluid align-start ma-0 pa-2 class="v80a1090-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle"
          :useBtnList="useBtnList"
          @btnRetrieve="btnRetrieve"
          @btnSave="btnSave"
          @btnPrint="btnPrint"
        >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2">
                      <i-label :label="'Ship No :'" />
                      <v-col cols="1">
                        <v-select
                          v-model="selectShipNo"
                          :items="shipNoList"
                          return-object
                          item-text="shipNo"
                          item-value="shipNo"
                          single-line
                          outlined
                          dense
                          height="32" />
                      </v-col>

                      <i-label :label="'Period :'" class="pl-2" />
                      <v-col cols="1">
                        <DxDateBox
                          :value="stDte"
                          height="32px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {stDte = e.value && getStrFormat(e.value)}"
                        />
                      </v-col>
                      <span class="px-2 d-flex align-center text-h6"> ~ </span>
                      <v-col cols="1">
                        <DxDateBox
                          :value="edDte"
                          height="32px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {edDte = e.value && getStrFormat(e.value)}"
                        />
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters class="pt-1">
              <v-col>
                <DxDataGrid
                  class="listBox"
                  :ref="v80a1090Ref"
                  :data-source="dataList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="id" 
                  :focused-row-enabled="false"
                  :column-hiding-enabled="false" 
                  :sorting="{ mode: 'none' }"
                  :selection="{ mode: 'none' }"
                >
                  <DxPaging :enabled="false" />
                  <DxPager :visible="false" />
                  <DxColumn data-field="id" caption="No" alignment="center" :allow-editing="false" width="3%" />
                  <DxColumn data-field="shipNo" caption="SHIP NO" alignment="center" :allow-editing="false" width="5%" />
                  <DxColumn data-field="block" caption="BLOCK" alignment="center" :allow-editing="false" width="4%" />
                  <DxColumn data-field="newLotGbn" caption="LOT" alignment="center" :allow-editing="false" width="3%" />
                  <DxColumn data-field="nextAssy" caption="POST LINE" alignment="center" :allow-editing="false" width="6%" />
                  <DxColumn data-field="nextAssyStg" caption="POST ASS'Y" alignment="center" :allow-editing="false" width="6%" />
                  <DxColumn caption="BLOCK WEIGHT / COUNT">
                    <DxColumn data-field="bltWeight" caption="WEIGHT(KG)" alignment="right" :allow-editing="false" width="6%" data-type="number" :format="format" />
                    <DxColumn data-field="bltQty" caption="BLT CNT" alignment="right" :allow-editing="false" width="6%" data-type="number" :format="format" />
                    <DxColumn data-field="pcsQty" caption="PCS CNT" alignment="right" :allow-editing="false" width="6%" data-type="number" :format="format" />
                  </DxColumn>                  
                  <DxColumn data-field="wkstpldt" caption="P.P START" alignment="center" :allow-editing="false" width="6%" />
                  <DxColumn caption="POST STAGE">
                    <DxColumn data-field="postMidppSt" caption="MID PP ST DATE" alignment="center" :allow-editing="false" width="8%" />
                    <DxColumn data-field="actualPsd" caption="RESULT ST DATE" alignment="center" :allow-editing="false" width="8%" />
                  </DxColumn>
                  <DxColumn caption="T-BAR RESULT">
                    <DxColumn data-field="respNm" caption="WORK GROUP" alignment="center" :allow-editing="false" width="7%" />
                    <DxColumn data-field="resultSt" caption="START" alignment="center" :allow-editing="true" data-type="date" format="yyyy-MM-dd"
                                          :set-cell-value="setResultSt" />
                    <DxColumn data-field="resultFi" caption="FINISH" alignment="center" :allow-editing="true" data-type="date" format="yyyy-MM-dd"
                                          :set-cell-value="setResultFi" />
                  </DxColumn>
                  <DxColumn data-field="deliverDt" caption="DELIVERY DATE" alignment="center" :allow-editing="true" data-type="date" format="yyyy-MM-dd"
                                        :set-cell-value="setDeliverDt" />
                </DxDataGrid>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import notify from 'devextreme/ui/notify'
import { reportView } from '@/api/view/hip/common/common'
import { getDateFormat, getCurrentDate } from '@/utils/common'
import { getV80ShipNo } from '@/api/view/hip/8/v80a1040'
import { v80a1090List, v80a1090Save } from '@/api/view/hip/A/v80a1090'

export default {
  name: 'v80a1090',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox
  },
  data() {
    return {
      makerCd: this.$store.state.user.makerCd,
      userId: this.$store.state.user.userId,
      menuTitle: this.$route.meta.title.replace(/\(Jeil\)/g, 'Management [Same HB01 on MIS]'),
      v80a1090Ref: 'v80a1090Ref',
      useBtnList: ['btnRetrieve', 'btnSave', 'btnPrint'],
      selectShipNo: null,
      shipNoList: [],
      stDte: '',
      edDte: '',
      format: '#,##0.######',
      dataList: [

      ]
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.v80a1090Ref)
    }
  },
  methods: {
    getStrFormat(date) {
      return getDateFormat(date)
    },
    async init() {
      this.gridInstance.option('defaultPaging', false)

      this.stDte = getCurrentDate({ dd: -20 })
      this.edDte = getCurrentDate()

      await this.getShipNoList()
    },
    async getShipNoList() {
      const param = {
        shipGu: ''
      }

      await getV80ShipNo(param).then(res => {
        this.shipNoList = res.list

        if(this.shipNoList.length > 0) {
          this.selectShipNo = this.shipNoList[0]
        }
      })
    },
    btnRetrieve() {
      this.dataList = []

      const param = {
        stDte: this.stDte,
        edDte: this.edDte,
        shipNo: this.selectShipNo.shipNo
      }

      // console.log('v80a1090List Param', param)

      this.openLoading()
      v80a1090List(param).then(res => {
        // console.log('v80a1090List Res', res)

        let data = res.list

        for(let i = 0; i < data.length; i++) {
          data[i].id = i + 1
        }

        this.dataList = data
      }).finally(() => {
        this.endLoading()
      })
    },
    async btnSave() {
      if(this.dataList.length < 1) {
        this.vToastify(this.$t('No data to Save!.'), 'warn')
        return
      }

      await this.gridInstance.saveEditData()

      let saveData = this.dataList.slice()
      saveData.forEach(row => {
        row.userId = this.userId
      })

      this.openLoading()      
      v80a1090Save(saveData).then(res => {
        const msg = res.body
        if(msg === 'OK') {
          notify(this.$t('Save is completed.'), 'success', 3000)
          this.btnRetrieve()
        } else {
          this.vToastify(this.$t(`An error was occured.<br>${msg}`), 'warn')
          return
        }
      }).finally(() => {
            this.endLoading()
          })
    },
    btnPrint() {
      let param = {
        as_ship_no: this.selectShipNo.shipNo,
        as_st_date: this.stDte,
        as_fi_date: this.edDte,
        fileName: 'v80a1090.jrxml'
      }

      this.openLoading()
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    setResultSt(newData , value , currRow){
      newData.resultSt = getDateFormat(value)
    },
    setResultFi(newData , value , currRow){
      newData.resultFi = getDateFormat(value)
    },
    setDeliverDt(newData , value , currRow){
      newData.deliverDt = getDateFormat(value)
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>

</style>